import React from "react";
import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";

interface ErrorFallbackProps {
  error: Error;
  componentStack: string | null;
  eventId: string | null;
  resetError: () => void;
}

/**
 * Error fallback component for Sentry.ErrorBoundary
 * Displays a user-friendly error message when an unhandled error occurs
 */
export const SentryErrorFallback: React.FC<ErrorFallbackProps> = ({
  resetError,
}) => {
  const { t } = useTranslation();

  const handleGoHome = () => {
    window.location.href = "/";
  };

  const handleRetry = () => {
    resetError();
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "24px",
      }}
    >
      <Result
        status="error"
        title={t("error.unexpected_title", "Algo sali\u00f3 mal")}
        subTitle={t(
          "error.unexpected_subtitle",
          "Ha ocurrido un error inesperado. Nuestro equipo ha sido notificado y estamos trabajando para solucionarlo.",
        )}
        extra={[
          <Button type="primary" key="retry" onClick={handleRetry}>
            {t("error.retry", "Reintentar")}
          </Button>,
          <Button key="home" onClick={handleGoHome}>
            {t("error.go_home", "Ir al inicio")}
          </Button>,
        ]}
      />
    </div>
  );
};

export default SentryErrorFallback;
